import {LeaveTypeColumnConfig} from "./leavesReport/LeaveReportConfig"
import {CustomersProjectsSelectionQualifier} from "../constants"
import messageResource from "../messageResource"
import {DateFormat} from "../date_format"
import {Feature, isEnabled} from '../features/index'
import {BillingSummaryReportInfo, LeaveTypeSelectionQualifier, TimeApprovalStatus} from 'constants'
import EVAReportParametersFormatter from './estimatedVsActualReport/ParametersFormatter'
import BaseReportFormatUtils from './FormatUtils'
import ATReportParamsStringBuilder from './reportParamsStringBuilder/ATReportParamsStringBuilder'
import {escapeHtmlSymbols} from '../atUtils'

const ReportPrintableHeadersBuilder = function () {}

ReportPrintableHeadersBuilder.prototype.init = function ( data ) {
    this.isFilteredByAssignments = data.isFilteredByAssignments;

    this.paramStringBuilder = new ATReportParamsStringBuilder({
        data: {
            users: data.users,
            userGroupsFeatureEnabled: isEnabled(Feature.UGR),
            userGroups: data.userGroups,
            timeZoneGroups: data.timeZoneGroups,
            cpList: data.cpList,
            leaveTypesMap: data.leaveTypesMap,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
    })

    return this;
};

ReportPrintableHeadersBuilder.prototype._customerFormatter = {
    format: function(customer) {
        return customer.name;
    }
};

ReportPrintableHeadersBuilder.prototype._projectFormatter = {
    format: function(project) {
        return project.name;
    }
};

ReportPrintableHeadersBuilder.prototype._userFormatter = {
    format: function (user) {
        return BaseReportFormatUtils.getFormattedUser( user.firstName, user.lastName, user.middleName, user.username)
    }
};

ReportPrintableHeadersBuilder.prototype._userGroupFormatter = {
    format: function(group) {
        return group.name;
    }
};

ReportPrintableHeadersBuilder.prototype._leaveTypesFormatter = {
    format: function ( leaveType ) {
        return leaveType.name;
    }
};

ReportPrintableHeadersBuilder.prototype._getCPKeySuffix = function () {
    return (this.isFilteredByAssignments) ? '_filtered' : '';
};

ReportPrintableHeadersBuilder.prototype._toEmphasis = function( str ) {
    return '<span class="param">' + str + '</span>';
};

ReportPrintableHeadersBuilder.prototype._getNames = function( objects, formatter, delimiter ) {
    if( !delimiter ) delimiter = ',';
    let names = '';
    for (let i = 0; i < objects.length - 1; i++)
    {
        names += formatter.format(objects[i]) + delimiter + ' ';
    }
    if (objects.length)
    {
        names += formatter.format(objects[objects.length - 1]);
    }
    return escapeHtmlSymbols(names);
};

ReportPrintableHeadersBuilder.prototype.addCPSelectionParamsStringToArray = function(cpSelection, array) {
    const keySuffix = this._getCPKeySuffix()

    if (cpSelection.qualifier === CustomersProjectsSelectionQualifier.ALL_ACTIVE
        || cpSelection.qualifier === CustomersProjectsSelectionQualifier.ALL) {
        const activeOnly = cpSelection.qualifier === CustomersProjectsSelectionQualifier.ALL_ACTIVE
        const label = messageResource.getEscapedMessage('projects_customers_selector.customers_and_projects') + ':'
        let value
        if (activeOnly)
            value = messageResource.getEscapedMessage("projects_customers_selector.all_active_projects_customers" + keySuffix)
        else
            value = messageResource.getEscapedMessage("projects_customers_selector.all_projects_customers" + keySuffix)
        array.push(new PrintableHeader().init(label, value))
    }
    else {
        const customers = this.paramStringBuilder.getFilteredCustomers(cpSelection)
        const projects = this.paramStringBuilder.getFilteredProjects(cpSelection)
        let label, names

        if (customers.length) {
            const customerKey = (customers.length === 1) ? "common.Customer" : "common.Customers"
            label = messageResource.getEscapedMessage(customerKey) + ':'

            let postfix = "projects_customers_selector.with_all_projects" + keySuffix

            postfix = this._toEmphasis(messageResource.getEscapedMessage(postfix))
            names = this._getNames(customers, this._customerFormatter) + ' ' + postfix
            array.push(new PrintableHeader().init(label, names))
        }
        names = ''
        if (projects.length) {
            const projectKey = (projects.length === 1) ? "common.Project" : "common.Projects"
            label = messageResource.getEscapedMessage(projectKey) + ':'

            names = this._getNames(projects, this._projectFormatter)
            array.push(new PrintableHeader().init(label, names))
        }
        else if (customers.length === 0) {
            array.push(new PrintableHeader().init(
                messageResource.getEscapedMessage('common.Projects') + ':',
                messageResource.getEscapedMessage('report.no_projects')
            ))
        }
    }
}

ReportPrintableHeadersBuilder.prototype.addStaffSelectionParamsToArray = function ( userSelection, array ) {
    const label = this._getStaffSelectionLabelToArray();
    array.push(new PrintableHeader().init(label, this.paramStringBuilder.getUserSelectionParamString(userSelection)))
}

ReportPrintableHeadersBuilder.prototype._getStaffSelectionLabelToArray = function() {
    return messageResource.getMessage("report.staff_label");
};

ReportPrintableHeadersBuilder.prototype.addTimeApprovalStatusToArray = function ( timeApprovalStatus, array ) {
    if (isEnabled(Feature.TTA) || timeApprovalStatus !== TimeApprovalStatus.BOTH )
    {
        const label = messageResource.getMessage( "report.time_track_status" ) + ":";
        let value = '';

        switch( timeApprovalStatus )
        {
            case TimeApprovalStatus.BOTH:
            {
                value = messageResource.getMessage( "report.form.show_both_approved_and_not" );
                break;
            }
            case TimeApprovalStatus.APPROVED:
            {
                value = messageResource.getMessage( "report.form.show_only_approved" );
                break;
            }
            case TimeApprovalStatus.NOT_APPROVED:
            {
                value = messageResource.getMessage( "report.form.show_only_not_approved" );
                break;
            }
        }
        array.push( new PrintableHeader().init( label, value ) );
    }
};

ReportPrintableHeadersBuilder.prototype.addDateRangeHeaderString = function( dateRangeSelection ) {
    return messageResource.getMessage( "range.custom.pattern", [
        new DateFormat( window.SystemSettings.dateFormat ).formatDate( dateRangeSelection.fromDate.parseJSONDate() ),
        new DateFormat( window.SystemSettings.dateFormat ).formatDate( dateRangeSelection.toDate.parseJSONDate() ) ] );
};

ReportPrintableHeadersBuilder.prototype.addDateRangeHeaderStringParsed = function( dateRangeSelection ) {
    return messageResource.getMessage( "range.custom.pattern", [
        new DateFormat( window.SystemSettings.dateFormat ).formatDate( dateRangeSelection.fromDate ),
        new DateFormat( window.SystemSettings.dateFormat ).formatDate( dateRangeSelection.toDate ) ] );
};

ReportPrintableHeadersBuilder.prototype.addEvaDateHeaderString = function( dateSelection ) {
    return messageResource.getMessage("report.budgeted_vs_actual.view.printable_date_range_prefix")
           + ' ' + new DateFormat( window.SystemSettings.dateFormat ).formatDate( dateSelection.date.parseJSONDate() );
};

ReportPrintableHeadersBuilder.prototype.addEvaDateHeaderStringParsed = function( dateSelection ) {
    return messageResource.getMessage("report.budgeted_vs_actual.view.printable_date_range_prefix")
           + ' ' + new DateFormat( window.SystemSettings.dateFormat ).formatDate( dateSelection.date);
};

ReportPrintableHeadersBuilder.prototype.addLeaveTypesParamsToArray = function ( leaveTypeSelection, columnsConfig, array ) {
    if (columnsConfig === LeaveTypeColumnConfig.BALANCES_ONLY)
        return;

    const label = messageResource.getMessage( "report.leave_types.label" );
    let value = '';

    switch ( leaveTypeSelection.qualifier )
    {
        case LeaveTypeSelectionQualifier.ALL:
        {
            value =  messageResource.getMessage( "report.leave_types.all" );
            break;
        }
        case LeaveTypeSelectionQualifier.SELECTED:
        {
            const leaveTypes = this.paramStringBuilder.getFilteredLeaveTypes( leaveTypeSelection.leaveTypes );
            value = this._getNames( leaveTypes, this._leaveTypesFormatter );
            break;
        }
    }
    array.push( new PrintableHeader().init( label, value ) );
};

ReportPrintableHeadersBuilder.prototype.addTaskSelectionParamsStringToArray = function(tasksConfig, includeNotEstimated, includeNotStarted, dateSelectionJSON, array) {
    const label = messageResource.getMessage("common.Tasks") + ':'
    const value = new EVAReportParametersFormatter().init({})
                                                    .formatTaskSelectionParamsString(
                                                        tasksConfig,
                                                        includeNotEstimated,
                                                        includeNotStarted,
                                                        {
                                                            dateSelection: dateSelectionJSON,
                                                            isParsed: true
                                                        }
                                                    )

    array.push(new PrintableHeader().init(label, value))
}

ReportPrintableHeadersBuilder.prototype.addBillableTaskSelectionParamsStringToArray = function( reportInfo, array ) {
    let messageKey = '';
    switch (reportInfo) {
        case BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS:
            messageKey = "report.billing_summary.non_billable_only";
            break;
        case BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS:
            messageKey = "report.billing_summary.billable_nonbillable";
            break;
        default:
            messageKey = "report.billing_summary.billable_only";
    }
    array.push( new PrintableHeader().init( messageResource.getMessage( "common.Tasks" ) + ":", messageResource.getMessage( messageKey ) ) );
};

ReportPrintableHeadersBuilder.prototype.addBillableReportTypeParamsStringToArray = function( reportType, array ) {
    const label = messageResource.getMessage( "report.billing_summary.report_type_label" );
    let messageKey = '';
    switch (reportType)
    {
        case "ALL_TIME_WITHIN_DATE_RANGE":
            messageKey = "report.billing_summary.time_for_date_range";
            break;
        case "ONLY_FOR_COMPLETED_TASKS":
            messageKey = "report.billing_summary.time_task_completed_for_date_range";
            break;
    }
    array.push( new PrintableHeader().init( label, messageResource.getMessage( messageKey ) ) );
};

class PrintableHeader {
    init(label, value) {
        this.label = label;
        this.value = value;
        return this;
    };
}

export default ReportPrintableHeadersBuilder


// WEBPACK FOOTER //
// ./web/js/reports/ReportPrintableHeadersBuilder.js